import { defineComponent as _defineComponent } from 'vue'
import TileGridWidgetBannerTile from './tiles/TileGridWidgetBannerTile.vue';
import TileGridWidgetImageTile from './tiles/TileGridWidgetImageTile.vue';
import TileGridWidgetSplitTile from './tiles/TileGridWidgetSplitTile.vue';
import {
	TileGridWidgetBannerTile as BannerTileType,
	TileGridWidgetImageTile as ImageTileType,
	TileGridWidgetData,
	TileGridWidgetInvalidTile,
	TileGridWidgetSection,
	TileGridWidgetSectionType,
	TileGridWidgetTile,
	TileGridWidgetTileShape,
	TileGridWidgetTileType,
} from 'JS/dxp/types/widgets/tile-grid-widget';
import { chunks } from 'JS/utilities/array';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridSection',
  props: {
    section: null,
    data: null,
    startingPromoIndex: null
  },
  setup(__props: any) {

const props = __props as {
	section: TileGridWidgetSection;
	data: TileGridWidgetData;
	startingPromoIndex: number;
}



const sectionTypeClass = computed(() => {
	return [
		{ 'dxp-tile-grid-widget-section--primary': props.section.type === TileGridWidgetSectionType.Primary || props.section.type === TileGridWidgetSectionType.Halves },
		{ 'dxp-tile-grid-widget-section--split-quarter': props.section.type === TileGridWidgetSectionType.Quarters && isGallerySection.value },
		{ 'dxp-tile-grid-widget-section--sixths': props.section.type === TileGridWidgetSectionType.Sixths },

	];
});

const tileBaseClass = 'dxp-tile-grid-widget-section__tile';

const tiles = computed(() => props.section.tiles
	.filter(isValidTile)
	.map((tile, idx) => {
		const classes = {
			[tileBaseClass]: true,
			[`${tileBaseClass}--half`]: tile.shape === TileGridWidgetTileShape.Half,
			[`${tileBaseClass}--quarter`]: tile.shape === TileGridWidgetTileShape.Quarter,
			[`${tileBaseClass}--third`]: tile.shape === TileGridWidgetTileShape.Third,
			[`${tileBaseClass}--full`]: tile.shape === TileGridWidgetTileShape.Full,
			[`${tileBaseClass}--fifth`]: tile.shape === TileGridWidgetTileShape.Fifth,
			[`${tileBaseClass}--sixth`]: tile.shape === TileGridWidgetTileShape.Sixth,
		};

		let individualTiles: (ImageTileType | BannerTileType)[] = [];
		if (tile.type === TileGridWidgetTileType.Split) {
			individualTiles = tile.imageTiles;
		} else {
			individualTiles = [tile];
		}

		const promoAttrs = individualTiles.map((t, i) => {
			const splitTilePosition = individualTiles.length > 1 ? `_${i}` : '';

			return createPromoDataAttributes({
				promoId: t.linkUrl.replace('https://www.farmandfleet.com', ''),
				promoName: t.altText,
				creativeSlot: `dxp_tile_${props.startingPromoIndex + idx + 1}${splitTilePosition}`,
				creativeName: 'dxp_tiles_0',
			});
		});

		return {
			tile,
			classes,
			promoAttrs,
		};
	}));

const rows = computed(() => chunks(props.data.tilesPerRowBySectionType[props.section.type], tiles.value));

function isValidTile(tile: TileGridWidgetTile): tile is Exclude<TileGridWidgetTile, TileGridWidgetInvalidTile> {
	return tile.type !== TileGridWidgetTileType.Invalid;
}

const isGallerySection = computed(()=> {
	return props.section.tiles.some(tile => tile.type === TileGridWidgetTileType.Split);
});


return { __sfc: true,props, sectionTypeClass, tileBaseClass, tiles, rows, isValidTile, isGallerySection, TileGridWidgetBannerTile, TileGridWidgetImageTile, TileGridWidgetSplitTile, TileGridWidgetTileType }
}

})